<template>
  <div>
    <a-modal
      v-model="visible"
      title="选择对比原料"
      @ok="handleOk"
      :width="900"
      destroyOnClose
      @cancel="hideModal"
    >
      <div class="differ">
        <!-- v-on:blur="search" -->
        <a-select
          placeholder="请选择工厂"
          style="width: 240px;margin-right: 10px;"
          v-model="searchText.factoryId"
          @change="onChangeFactory"
        >
          <a-select-option v-for="d in factoryList" :key="d.factoryId">
            <a-tooltip>
              <template slot="title">
                {{ d.name }}({{ d.code }})
              </template>
              {{ d.name }}
            </a-tooltip>
            
          </a-select-option>
        </a-select>
        <a-input
          v-model="searchText.name"
          placeholder="请输入原料名称/代码"
          allow-clear
          v-on:keyup.enter="search"
        >
          <a-tooltip slot="suffix" title="">
            <a-icon type="search" style="color: rgba(0, 0, 0, 0.45)" @click="search" />
          </a-tooltip>
        </a-input>

        <a-cascader
          :options="typeList"
          :load-data="loadData"
          change-on-select
          @change="onChange"
          style="width: 250px"
          placeholder="请选择原料类型"
        />
      </div>

      <!-- 表单 -->
      <a-table
        :columns="columns"
        bordered
        :data-source="list"
        :pagination="pagination"
        :scroll="{ y: 340 }"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
          type: 'radio',
        }"
        :rowKey="(record) => record.id"
      >

        <template slot="name" slot-scope="text, record">
            <span>{{record.aliasName ? record.aliasName :record.name}}</span>
          </template>

      </a-table>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title: "原料名称",
    dataIndex: "name",
    scopedSlots: { customRender: "name" },
  },
  // {
  //   title:"原料别名",
  //   dataIndex:"aliasName"
  // },
  {
    title: "代码",
    dataIndex: "code",
  },
  {
    title: "类型",
    dataIndex: "rawTypeName",
  },
];
export default {
  props: ['factoryList'],
  data() {
    return {
      visible: false,
      factoryId: window.localStorage.getItem("factoryId"),
      searchText: {
        name: "",
        typeId: "",
      },
      columns,
      list: [],
      typeList: [],
      choose: 0, //设置当前添加原料是给第一个对象添加还是第二个
      selectedRowKeys: [], //保存table单选选中的id
      selectedRows: [], //保存table单选选中的对象
      pagination: {
        pageSizeOptions: ["10", "20", "30", "40", "50", "100"],
        total: 0,
        pageSize: 20,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current;
          this.getList({ current, pageSize, ...this.searchText });
        }, //选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.current = 1;
          this.pagination.pageSize = pageSize;
          this.getList({ current: 1, pageSize, ...this.searchText });
        }, //每页多少条
      },
      searchList: [], //输入框搜索值
    };
  },
  mounted() {
    this.getList();
    this.getTypeList();
  },
  watch: {
    searchText: {
      handler(newName) {
        if(newName.name=='')
        this.getList(newName);
      },
      deep: true,
    },
  },
  methods: {
    init(str) {
      this.pagination.current = 1;
      this.pagination.pageSize = 20;
      this.visible = !this.visible;
      this.choose = str;
      if(this.visible){
        this.searchText.factoryId = window.localStorage.getItem('factoryId')
        this.searchText.name = undefined
        this.selectedRowKeys = []
        this.selectedRows = []
        this.list = []
        this.getList()
      }
    },

    handleOk() {
      this.$emit("getDifferCompareId", this.choose, this.selectedRows[0]);
      this.visible = !this.visible;
    },

    //获取级联选中的数据,点击搜索
    onChange(value) {
      this.searchText.typeId = value[value.length - 1];
      // this.pagination.pageSize = 20
      this.pagination.current = 1
      this.getList(this.searchText);
    },
    onChangeFactory(){
      // if(!this.searchText.factoryId){
      //   this.searchText.factoryId = window.localStorage.getItem('factoryId')
      // }
      // this.pagination.pageSize = 20
      this.pagination.current = 1
      this.getList(this.searchText);
    },

    // 输入框失焦，点击搜索
    search() {
      // this.pagination.pageSize = 20
      this.pagination.current = 1
      this.getList(this.searchText);
    },

    // table选项框，获取单选数据并保存
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys; //获取选中的id
      this.selectedRows = selectedRows;
    },

    //获取原料数据，可传入数据进行查询。
    async getList(obj) {
      let {factoryId} = obj || {}
      let {pageSize,current} = this.pagination || {}
      let params = {
        ...obj,
        current,
        size: pageSize,
        factoryId: factoryId ? factoryId : this.factoryId,
      };
      let res = await this.$get("/nhf-app/factorystaffraw/myRawpage", params);
      let { success, data } = res;
      if (success) {
        let {total,size,records} = data || {}
        this.list = records;
        this.pagination.total = total
        this.pagination.pageSize = size
      }
    },

    //获取指标类型
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      setTimeout(() => {
        targetOption.loading = false;
        // this.$emit('getTypeList',{targetOption,id:targetOption.id})
        this.getTypeList(targetOption.id, targetOption) || [];
        // this.typeList = [...this.typeList];
      }, 0);
    },

    getTypeList(parentId = 0, record) {
       // 获取片区id
      let obj = window.localStorage.getItem('factoryDetail')
      let factoryDetail = obj ? JSON.parse(obj) : {}
      let { deptId } = factoryDetail
      // this.$http.get(`/nhf-core-data/basictype/listByParentIdWithOutSpecialTypeId?category=raw&parentId=${parentId}`)
      this.$http.get(`/nhf-core-data/basictype/listByParentIdWithOutSpecialTypeIdAndSatlimit?category=raw&parentId=${parentId}&deptId=${deptId}`)
        .then((res) => {
          let { success, data = [] } = res;
          if (success) {
            data &&
              data.map((el) => {
                el.value = el.id;
                el.label = el.name;
                el.isLeaf = !el.hasChildren;
                return el;
              });
            if (record) {
              if (data.length) {
                record.children = data;
              } else {
                record.isLeaf = true;
              }
              this.typeList = [...this.typeList];
            } else {
              this.typeList = data;
            }
          }
        });
    },

    hideModal(){
      this.searchText={}
      // this.getList()
    },
  },
};
</script>

<style lang="scss" scoped>
.differ {
  margin-bottom: 16px;
  display: flex;
  .ant-input-affix-wrapper {
    width: 250px;
    margin-right: 10px;
  }
}
.tableBox {
  padding: 0;
}
</style>